import { ProviderType } from "../App";

export const getMaxCompetitorPrice = (
  competitors: ProviderType[],
  houseHoldType: number
) => {
  if (!competitors.length) return 0;

  return Math.max(
    ...competitors.map((competitor) => competitor.value[houseHoldType]),
    0
  );
};
